import { render, staticRenderFns } from "./librosXinstituciondespliegue.vue?vue&type=template&id=17e9ee50"
import script from "./librosXinstituciondespliegue.vue?vue&type=script&lang=js"
export * from "./librosXinstituciondespliegue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports